import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { PageHeader } from '@/components/layout/AppShell'
import { Table, THead, Th, Tr, Td } from '@/components/ui/data-table'
import { GLOSSARY } from '@/lib/glossary'
import { cn } from '@/lib/utils'

/** Every on-screen term, its meaning and the agreement clause that defines it. */
export function Glossary() {
  const { hash } = useLocation()
  const target = hash.slice(1)
  useEffect(() => {
    if (target) document.getElementById(target)?.scrollIntoView({ block: 'center' })
  }, [target])

  return (
    <>
      <PageHeader
        title="Glossary"
        description="The terms used across this dashboard, as defined in the Atarim Reseller Partner Agreement."
      />
      <Table>
        <THead>
          <Th>Term</Th>
          <Th>Meaning</Th>
          <Th>Clause</Th>
        </THead>
        <tbody>
          {GLOSSARY.map((g) => (
            <Tr key={g.id}>
              <Td className={cn('scroll-mt-24 font-medium', target === g.id && 'bg-ata-gold/10')}>
                <span id={g.id}>{g.term}</span>
              </Td>
              <Td className="max-w-xl">{g.meaning}</Td>
              <Td className="whitespace-nowrap text-muted-foreground">{g.clause ? `Clause ${g.clause}` : '—'}</Td>
            </Tr>
          ))}
        </tbody>
      </Table>
    </>
  )
}
